import { ReactElement } from "react";
import { IContentAreaProps, IState } from "../../../../types";
import FilterComponentBase from "../../../../components/filterComponentBase";
import SkeletonView from "../../../../components/skeletonView";
import BbcTable from "./bbcTable";
import { useFetch } from "../../../../system/useFetch";
import { useSelector } from "react-redux";
import { Alert } from "@mui/material";
import { IBBCRecordReport } from "./types";
import useDimensions from "../../../../system/useDimensions";


const BBCReport = ({ parentSize }: IContentAreaProps): ReactElement => {
  const filter = useSelector((state: IState) => state.filter);
  const [ref, dimensions] = useDimensions<HTMLDivElement>();
  const { loading, error, data } = useFetch<IBBCRecordReport[]>(
    {
      module: "mill",
      query: "getBBCReportByFilter",
      payload: { ...filter.remote }
    });

  const gridStyle = {
    ...parentSize,
    gridTemplateRows: "auto 1fr",
    gridTemplateColumns: "1fr",
    gap: "8px"
  };


  return (
    <div className="display-grid" style={gridStyle}>
      <FilterComponentBase loading={loading}/>
      {loading && <SkeletonView  parentSize={parentSize}/>}
      {error && <Alert severity="warning">{error.message}</Alert>}

      {!loading && !error &&
        <div className="grid-cell" ref={ref}>
          <BbcTable parentSize={{ width: dimensions.width, height: dimensions.height - 4 }} records={data ?? []} />
        </div>
      }
    </div>
  );
};

export default BBCReport;